<template>
  <div class="page-top-wrap">
    <div class="wrap pt-20 pb-20">
      <div class="big_screen_show container">
        <div class="logo_wrap">
          <img src="../assets/img/logo.png" alt />
        </div>
        <nav class="clearfix fs-20">
          <li
            v-for="(v, i) in menuList"
            :key="i"
            class="pr fl"
            @mouseover="mouseOver(i)"
            @mouseleave="mouseLeave"
          >
            <div class="flex_item_con">
              <a
                @click="handleClickPcMenu(i)"
                :class="['color-fff', { navActive: i == navActiveIndex }]"
                >{{ v.title }}</a
              >
              <!-- <span :class="['color-fff', { navActive: i == navActiveIndex }]">{{ v.en }}</span> -->
            </div>
            <template v-if="v.subMenu">
              <div
                ref="subNav "
                class="pa subNav"
                v-if="mouseOverIndex == i && showSubNac"
              >
                <li
                  class="mt-20 mb-20 fs-16"
                  v-for="(sv, si) in v.subMenu"
                  :key="si"
                >
                  <img
                    class="mr-10"
                    style="width: 6px"
                    src="../assets/img/icon_dot.png"
                  />
                  <div class="flex_item_con">
                    <a
                      @click="handleClickPcSubMenu(i, sv)"
                      class="ml-10 color-666"
                      >{{ sv.subTitle }}</a
                    >
                    <!-- <span>{{ sv.en }}</span> -->
                  </div>
                </li>
              </div>
            </template>
          </li>
        </nav>
      </div>
    </div>
    <div class="lauguage_wrap">
      <div class="wrap_item borders"  @click="changeLanguage('zh')">
        <img
          src="https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/cn.png"
        />
        <span>简体中文</span>
      </div>
      <div class="wrap_item" @click="changeLanguage('en')">
        <img
          src="https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/us.png"
        />
        <span>English</span>
      </div>
    </div>
    <div class="small_screen_show">
      <i
        class="el-icon-menu"
        slot="reference"
        @click="showMobile = !showMobile"
      ></i>
    </div>
    <div class="menu-mask" v-if="showMobile" @click="showMobile = false">
      <div class="menu_list">
        <div
          v-for="(item, index) in smenuList"
          :key="index"
          @click="handelJump(index)"
        >
          <span>{{ item.title }}</span>
          <span>{{ item.en }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { EventBus } from "@/utils/bus.js";

export default {
  data() {
    return {
      navActiveIndex: sessionStorage.getItem("navActiveIndex") || 0,
      mouseOverIndex: 0,
      showSubNac: false,
      showMobile: false,
      // 移动端菜单
      smenuList: [
        {
          // title: app.$t('homepage.home'),
          title: this.$t("homepage.home"),
          url: "/",
          en: "Home",
        },
        {
          title: this.$t("information.title"),
          url: "/schedule?tab=0",
          en: "Guide",
        },
        {
          title: "新闻中心",
          url: "/newsCenter?tab=0",
          en: "News",
        },
        {
          title: "展商",
          url: "/exhibitor?tab=0",
          en: "Exhibitor",
        },
        // {
        //   title: "票务信息",
        //   url: "/buyTicket?tab=0"
        // },
        {
          title: "媒体中心",
          url: "/mediaCenter?tab=0",
          en: "Media",
        },
        {
          title: "活动",
          url: "/activity?tab=0",
          en: "Activity",
        },
        {
          title: "历届回顾",
          url: "/history?tab=0",
          en: "History",
        },
      ],
      //pc端菜单
      menuList: [
        {
          // title: "首页",
          title: this.$t("homepage.home"),
          menuType: "0",
          url: "/",
          en: "Home",
        },
        {
          title: this.$t("information.title"),
          menuType: "1",
          en: "Information",
          subMenu: [
            {
              subTitle: this.$t("information.exhibition"),
              url: "/schedule?tab=0",
              en: "Exhibition",
            },
            {
              subTitle: this.$t("information.schedule"),
              url: "/schedule?tab=1",
              en: "Schedule",
            },
            {
              subTitle: this.$t("information.transportation"),
              url: "/schedule?tab=2",
              en: "Transportation",
            },
            {
              subTitle: this.$t("information.pavilion"),
              url: "/schedule?tab=3",
              en: "Pavilion",
            },
            {
              subTitle: this.$t("information.ticket"),
              url: "/schedule?tab=4",
              en: "Ticket",
            },
            {
              subTitle: this.$t("information.hotel"),
              url: "/schedule?tab=5",
              en: "Hotel",
            },
          ],
        },
        {
          title: this.$t("newscenter.title"),
          menuType: "1",
          en: "News Center",
          subMenu: [
            {
              subTitle: this.$t("newscenter.notice"),
              url: "/newsCenter?tab=0",
              en: "Notice",
            },
            {
              subTitle: this.$t("newscenter.news"),
              url: "/newsCenter?tab=1",
              en: "News",
            },

            // {
            //   subTitle: "防控指引",
            //   url: "/newsCenter?tab=2",
            // },
          ],
        },
        {
          title: this.$t("exhibitors.title"),
          menuType: "1",
          en: "Exhibitor",
          subMenu: [
            {
              subTitle: this.$t("exhibitors.invitation"),
              url: "/exhibitor?tab=0",
              en: "Invitation",
            },
            {
              subTitle: this.$t("exhibitors.service"),
              url: "/exhibitor?tab=1",
              en: "Service",
            },
            {
              subTitle: this.$t("exhibitors.manual"),
              url: "/exhibitor?tab=2",
              en: "Exhibitor's Manual",
            },
            {
              subTitle: this.$t("exhibitors.pavilion"),
              url: "/exhibitor?tab=3",
              en: "Pavilion",
            },
            {
              subTitle: this.$t("exhibitors.download"),
              url: "/exhibitor?tab=4",
              en: "Download",
            },
          ],
        },
        // {
        //   title: "票务信息",
        //   menuType: "1",
        //   subMenu: [
        //     {
        //       subTitle: "在线售票",
        //       url: "/buyTicket?tab=0"
        //     },
        //     {
        //       subTitle: "购票须知",
        //       url: "/buyTicket?tab=1"
        //     }
        //   ]
        // },
        {
          title: this.$t("mediacenter.title"),
          menuType: "1",
          en: "Media",
          subMenu: [
            {
              subTitle: this.$t("mediacenter.cooperation"),
              url: "/mediaCenter?tab=0",
              en: "Cooperation",
            },
            {
              subTitle: this.$t("mediacenter.pass"),
              url: "/mediaCenter?tab=1",
              en: "Media Pass",
            },
          ],
        },
        // {
        //   title: "关于我们",
        //   menuType: "1",
        //   subMenu: [
        //     {
        //       subTitle: "联系我们",
        //       url: "/aboutUs?tab=0"
        //     },
        //     {
        //       subTitle: "参展须知",
        //       url: "/aboutUs?tab=1"
        //     }
        //   ]
        // },
        {
          title: this.$t("activities.title"),
          menuType: "1",
          en: "Activities",
          subMenu: [
            {
              subTitle: this.$t("activities.conference"),
              url: "/activity?tab=0",
              en: "Press Conference",
            },
            {
              subTitle: this.$t("activities.meeting"),
              url: "/activity?tab=1",
              en: "Meetings&",
            },
          ],
        },
        {
          title: this.$t("review.title"),
          menuType: "1",
          en: "Review",
          subMenu: [
            {
              subTitle: this.$t("review.photo"),
              url: "/history?tab=0",
              en: "Photo",
            },
            // {
            //   subTitle: "视频",
            //   url: "/history?tab=1",
            //   en:"Video"
            // },
          ],
        },
      ],
    };
  },
  mounted() {
    EventBus.$on("resetNavActiveIndex", (index) => {
      this.navActiveIndex = index;
      sessionStorage.setItem("navActiveIndex", index);
    });
  },
  methods: {
    changeLanguage(text) {
      // e.preventDefault();
      console.log(text,1111);

      this._i18n.locale = text;
      console.log(this._i18n.locale);
      localStorage.setItem("lang", this._i18n.locale);
      window.location.reload();
    },
    handelJump(index) {
      this.navActiveIndex = index;
      this.showMobile = false;
      sessionStorage.setItem("navActiveIndex", index);
      this.$router.push({
        path: this.smenuList[index].url,
      });
    },

    // handleSelect(key, keyPath) {
    //   console.log(key);
    //   if (key.indexOf("-") == "-1") {
    //     this.$router.push({
    //       path: this.menuList[key].url,
    //     });
    //   } else {
    //     let tempArr = key.split("-");
    //     let subUrl = this.menuList[tempArr[0]].subMenu[tempArr[1]].url;
    //     if (subUrl == "/mediaCenter?tab=1") {
    //       let routeData = this.$router.resolve({ name: "mediaApply" });
    //       window.open(routeData.href, "_blank");
    //     } else {
    //       this.$router.push({
    //         path: subUrl,
    //       });
    //     }
    //   }
    // },
    handleClickPcMenu(index) {
      this.navActiveIndex = index;
      sessionStorage.setItem("navActiveIndex", index);
      if (index === 0) {
        this.$router.push({
          path: "/",
        });
      } else {
        this.$router.push({
          path: this.menuList[index].subMenu[0].url,
        });
      }
    },
    handleClickPcSubMenu(pIndex, subItem) {
      this.navActiveIndex = pIndex;
      sessionStorage.setItem("navActiveIndex", pIndex);
      if (subItem.url === "/mediaCenter?tab=1") {
        let routeData = this.$router.resolve({ name: "mediaApply" });

        window.open(routeData.href, "_blank");
      } else {
        this.$router.push({
          path: subItem.url,
        });
      }
    },
    mouseOver(index) {
      this.mouseOverIndex = index;
      this.showSubNac = true;
    },
    mouseLeave() {
      this.showSubNac = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.page-top-wrap {
  display: flex;
  justify-content: center;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  margin: 0 auto;
  z-index: 99;
  align-items: center;
  .logo_wrap {
    margin-right: 50px;
    width: 136px;
    height: 58px;
    > img {
      width: 100%;
      height: 100%;
    }
  }
}

.lauguage_wrap {
  display: flex;
  align-items: center;
  position: absolute;
  right: 30px;
  .borders{
    border-right: 1px solid #fff;
    margin-right: 20px;
  }
  >div  {
    display: flex;
    align-items: center;
    > img {
      width: 20px;
      height: 20px;
      margin-right: 10px;
      cursor: pointer;
    }
    > span {
      font-size: 16px;
      color: #fff;
      margin-right: 20px;
      cursor: pointer;
    }
  }
}
.wrap {
  width: 100%;
  // background-color: rgba(0, 0, 0, 0.5);
}
.big_screen_show {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.small_screen_show {
  color: #fff;
  visibility: hidden;
  position: absolute;
  right: 0;
  .el-icon-menu {
    font-size: 150px;
  }
}

.menu-mask {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  .menu_list {
    display: flex;
    flex-direction: column;
    align-items: center;
    background: #fff;
    position: absolute;
    right: 150px;
    top: 80px;
    > div {
      display: flex;
      flex-direction: column;
      border-bottom: 2px solid #ddd;
      height: 220px;
      justify-content: center;
      box-sizing: border-box;
      > span {
        font-size: 50px;
        // margin-bottom: 40px;
        width: 100%;
        text-align: center;
        height: 70px;
        line-height: 70px;
        color: #000;
        width: 400px;
      }
    }
  }
}

@media screen and (max-width: 1000px) {
  .big_screen_show {
    visibility: hidden;
  }
  .small_screen_show {
    visibility: visible;
  }
}

nav {
  display: flex;
  width: 100%;
  li {
    list-style: none;
    flex: 1;
    text-align: center;
    // padding: 0 3.5%;
  }
  .navActive {
    color: #42abff;
  }
  .subNav {
    background-color: #fff;
    left: 0;
    min-width: 100%;
    text-align: center;
    li {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      padding: 0 12px;
      white-space: nowrap;
      > div {
        flex: 1;
        > span {
          color: #000;
        }
      }
    }
  }
}
a:hover {
  cursor: pointer;
  color: #42abff;
  text-decoration: none;
}
.flex_item_con {
  display: flex;
  flex-direction: column;
  align-items: center;
  > span {
    font-size: 12px;
    // color: #000;
  }
}
</style>



// WEBPACK FOOTER //
// pageTop.vue?babcf448